import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown, ArrowRight } from '@phosphor-icons/react';
import { SiblingFigure } from '../characters/SiblingFigure';
import { siblings } from '../../data/siblings';
interface NamingContrastProps {
  compact?: boolean;
}
const SHIFTS = [['Portfolio', 'People'], ['Product architecture', 'Family story']];

/** The naming shift: portfolio term on the left, invitation on the right. */
export function NamingContrast({
  compact = false
}: NamingContrastProps) {
  return <motion.figure initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.3
  }} transition={{
    duration: 0.55,
    ease: [0.22, 1, 0.36, 1]
  }} className={['rounded-[24px] border border-[rgba(1,51,43,0.1)] bg-white', compact ? 'mt-6 p-4' : 'mt-8 p-6'].join(' ')} data-id="element-187" data-mp="2ldjwemtp6xmc">
      <div className={compact ? 'flex flex-col items-stretch gap-3' : 'grid grid-cols-[minmax(0,1fr)_auto_minmax(0,1.5fr)] items-center gap-5'} data-id="element-188" data-mp="9mo9vnzalg1e">
        <div className="rounded-[18px] border border-dashed border-[rgba(1,51,43,0.2)] px-4 py-5" data-id="element-189" data-mp="2ffsa7l0nnjjc">
          <span className="block font-body text-[9px] uppercase tracking-[0.24em] text-[rgba(1,51,43,0.35)]" data-id="element-190" data-mp="2ago1swlk1pu2">
            Portfolio architecture
          </span>
          <span className="mt-2.5 block font-body text-[12px] font-medium uppercase tracking-[0.2em] text-[rgba(1,51,43,0.5)]" data-id="element-191" data-mp="26homqj640cow">
            Filtek Family
          </span>
        </div>

        <span aria-hidden="true" className={compact ? 'flex justify-center text-primary' : 'text-primary'} data-id="element-192" data-mp="1wohm1bmbdkv5">
          {compact ? <ArrowDown size={18} weight="bold" data-id="element-193" data-mp="1mseajf5ko9vj" /> : <ArrowRight size={20} weight="bold" data-id="element-194" data-mp="1iq1gho06u0el" />}
        </span>

        <div className="rounded-[18px] bg-background px-5 py-5" data-id="element-195" data-mp="1ip83w6ejsgoj">
          <span className="block font-body text-[9px] uppercase tracking-[0.24em] text-primary" data-id="element-196" data-mp="1drznaa91skpe">
            Family story
          </span>
          <span className={['mt-2.5 block font-heading leading-[1.02] tracking-[-0.02em] text-white', compact ? 'text-[24px]' : 'text-[30px]'].join(' ')} data-id="element-197" data-mp="145f869itrmei">
            Meet the Filteks
          </span>
          <span className="mt-4 flex items-center" data-id="element-198" data-mp="z50vufa6xqao">
            {siblings.slice(0, 3).map((sibling, i) => <SiblingFigure key={sibling.id} role={sibling.id} className={['h-9 w-9 rounded-full ring-2 ring-background', i === 0 ? '' : '-ml-2.5'].join(' ')} data-id="element-199" data-mp="1muc046qr22tk" data-mpi={i} />)}
            <span className="ml-3 font-body text-[11px] leading-snug text-white/50" data-id="element-200" data-mp="1i1sld6gbt1n6">
              Characters, not codes.
            </span>
          </span>
        </div>
      </div>

      <figcaption className={['flex flex-wrap items-center gap-x-7 gap-y-2 border-t border-[rgba(1,51,43,0.1)]', compact ? 'mt-4 pt-4' : 'mt-6 pt-4'].join(' ')} data-id="element-201" data-mp="2akg4igbri6lm">
        {SHIFTS.map(([from, to]) => <span key={from} className="inline-flex items-center gap-2 font-body text-[10px] uppercase tracking-[0.18em] text-[rgba(1,51,43,0.45)]" data-id="element-202" data-mp="3q8w6bc54jtre">
            {from}
            <ArrowRight size={12} weight="bold" className="text-primary" aria-hidden="true" data-id="element-203" data-mp="3xi7o42w243z" />
            <span className="text-background" data-id="element-204" data-mp="3cd1y6vc6d8fc">{to}</span>
          </span>)}
      </figcaption>
    </motion.figure>;
}